<template>
  <div>
    <div class="dldeing">验 证 密 保</div>
    <div class="pin">
      <div>1、{{ arr[0].question }}</div>
      <van-field v-model="value" placeholder="请输入密保答案" />
      <div style="margin-top: 8px">2、{{ arr[1].question }}</div>
      <van-field v-model="value1" placeholder="请输入密保答案" />
      <van-field disabled style="display: none" />
      <div class="dlanniu" @click="dian">下 一 步</div>
    </div>
  </div>
</template>
<script>
import { userpassword } from "@/api/home";
import { Toast } from "vant";
export default {
  data() {
    return {
      value: "",
      value1: "",
      arr: [],
      roleType:this.$route.query.roleType,
      userId:this.$route.query.userId
    };
  },
  watch: {},
  components: {},
  methods: {
    dian() {
      let that = this;
      if (this.value == "" || this.value1 == "") {
        Toast("请输入密保答案！");
        return false;
      }
      let params = {
        roleType: this.roleType,
        userId: this.userId,
        useranswerList: [
          { answer: this.value, questionCode: this.arr[0].questionCode },
          { answer: this.value1, questionCode: this.arr[1].questionCode },
        ],
      };
      userpassword(params)
        .then((res) => {
          if(res.data.code=='0'){
            let data = JSON.stringify(params.useranswerList);
            let roleType = that.roleType;
            let userId = that.userId;
            this.$router.push({
              path: "/newpassword",
              query: {
                data: data,
                userId: userId,
                roleType: roleType,
              },
            });
          }
        })
        .catch((rdd) => {});
    },
  },
  mounted() {
    this.arr = JSON.parse(this.$route.query.data);
    // console.log( this.arr)
  },
};
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/my/second.vue